import React from 'react'
import { Link } from 'react-router-dom'

export default function WeddingStory({data}) {
  return (
    <>
      <section className="wedding-story-area header-gap">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-3 col-md-4">
              <div className="wedding-story-content">
                <span>{data?.title}</span>
                <Link to={"/contact-us"} className="arrow-butn">Contact Us <img src="/image/right-arrow.svg" alt="arrow" /></Link>
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <div className="wedding-story-content">
                <label>{data?.description}</label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
